import React, { useRef, useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ButtonWrapper from "../../components/Button";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogContent,
  IconButton,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { FaFilePdf, FaTimes, FaPencilAlt, FaFont, FaSave, FaEraser, FaUndo, FaRedo } from "react-icons/fa";
import { Loader } from "@egovernments/digit-ui-react-components";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { addFormMTDoc } from "@egovernments/digit-ui-module-core/src/redux/actions/formMT";
import axios from "axios";
import { PdfViewerModal } from "@egovernments/digit-ui-module-common/src/sharedComponents/PdfViewerModal";
import { FileUpload } from "@mui/icons-material";
import FileUploader from "../../reusableComponents/FileUploader2";
import DxfFileUploader from "../../reusableComponents/DxfFileUploader";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { set } from "lodash";
import { Tab } from "react-bootstrap";
// Create a new component for PDF viewing and editing

const Step4Comp = ({ formData, handleTabChange, isEmployee, isNocModule, onSelect }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  console.log("formDataInStep4", formData);
  const { t } = useTranslation();
  const defaultValues = formData ? { ...formData } : {};
  const { handleSubmit, control, setValue, trigger, getValues } = useForm({ defaultValues });
  const tenantId = Digit.ULBService.getStateId();
  const [drawingDetail, setDrawingDetail] = useState(formData?.drawingDetail || []);
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currFileStoreId, setCurrFileStoreId] = useState(null);
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [file2, setFile2] = useState(null);
  const [showError, setShowError] = useState(false);
  const [dxfFileUrl, setDxfFileUrl] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: "",
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const formRef = useRef(null);
  const onSubmit = (data) => {
    handleTabChange(4, data);
  };

  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: formData?.applicationNo,
        pdfType: "DI",
        fileStoreId: sanctionMapFileStoreId,
      };

      const getSign = await Digit.DscService.getSignParams({ SignRequest });

      setSigningParams({
        AuthToken: getSign?.SigningParameters?.authToken,
        SrcPdfB64: getSign?.SigningParameters?.pdfBase64,
        SignSettingName: getSign?.SigningParameters?.signSettingName,
        ReturnUrl: getSign?.SigningParameters?.returnURL,
        UserDataJson: getSign?.SigningParameters?.UserDataJson,
      });

      setOpen(true);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  // Safely extract compoundingDrawingDxf document
  const completeDrawingDxfFile = formData.documents.filter(
    (doc) => doc.documentType === "dxfDrawing" || doc?.documentType === "compoundingDrawingDxf"
  );
  console.log("completeDrawingDxfFile", completeDrawingDxfFile);
  useEffect(() => {
    if (!formData?.documents || formData.documents.length === 0) {
      console.log("No documents found in formData yet");
      return;
    }

    // Find the compoundingDrawingDxf document
    const completeDrawingDxfFile = formData.documents.filter((doc) => doc.documentType === "dxfDrawing");

    if (completeDrawingDxfFile?.length > 0) {
      const dxfFileStoreId = completeDrawingDxfFile[0]?.fileStoreId;
      if (dxfFileStoreId) {
        const url = `/filestore/v1/files/id?fileStoreId=${dxfFileStoreId}&tenantId=${tenantId}`;
        setDxfFileUrl(url);
        console.log("✅ DXF File URL:", url);
      } else {
        console.warn("⚠️ DXF fileStoreId missing in document");
        setDxfFileUrl(null);
      }
    } else {
      console.warn("⚠️ No compoundingDrawingDxf document found");
      setDxfFileUrl(null);
    }
  }, [formData, tenantId]);

  const sanctionMapFileStoreId = formData?.documents?.find((doc) => doc.documentType === "drawingPdf")?.fileStoreId;
  const drawingPdfUrl = formData?.drawingPdfUrlSelf;

  const validatePdfUrl = (url) => {
    if (!url) return false;
    if (url.startsWith("/")) return true; // allow relative URLs

    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const handleOpenPdf = async (url, index = null) => {
    console.log("DEBUG: handleOpenPdf called with URL:", url);
    // Validate URL before setting it
    if (!validatePdfUrl(url)) {
      console.log("Invalid PDF URL provided", "error");
      return;
    }
    setCurrentPdfUrl(url);
    setCurrFileStoreId(sanctionMapFileStoreId);
    setCurrentDocumentIndex(index);
    setPdfModalOpen(true);
    console.log("DEBUG: PDF modal opened");
  };
  const handlePdfSave = (fileStoreId, documentIndex) => {
    console.log("PDF saved with fileStoreId:", fileStoreId, "for document index:", documentIndex);
    setSavedFileStoreId(fileStoreId);
    try {
      const workflow = {
        action: "NOWORKFLOW",
        comments: "",
      };

      console.log("Drawing Detials 166", drawingDetail);

      // const updatedDrawingDetail = drawingDetail.map((item) => ({
      //   ...item,
      //   viewEditPdf: fileStoreId,
      // }));

      // console.log("UpdatedDrawingDetail 173", updatedDrawingDetail);

      const appData = {
        ...formData,
        workflow,
        // drawingDetail: updatedDrawingDetail,
        mapSubDetails: {
          ...formData?.mapSubDetails,
          viewEditPdf: fileStoreId,
        },
      };

      console.log("APPDATA for update", appData);

      updateApiCall.mutate(
        { BPA: appData },
        {
          onSuccess: (result) => {
            console.log("resultFromUpdate", result);
            onSelect("", result?.BPA?.[0]);
            // setDeveloperUpdateDocument("DocumentDetailsUpdated");
            // alert("Pdf Edited Succesfully");
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
    // Update the drawingDetail array with the new fileStoreId
    // if (documentIndex !== null && documentIndex !== undefined) {
    //   const updatedDrawingDetail = [...drawingDetail];
    //   updatedDrawingDetail[documentIndex] = {
    //     ...updatedDrawingDetail[documentIndex],
    //     viewEditPdfUrl: `/filestore/v1/files/id?fileStoreId=${fileStoreId}&tenantId=up&module=property-upload`,
    //   };
    //   setDrawingDetail(updatedDrawingDetail);
    // Also update the formData if needed
    // if (formData && formData.drawingDetail) {
    //   formData.drawingDetail[documentIndex] = updatedDrawingDetail[documentIndex];
    // }
    // }
  };
  const columns = [
    { id: "pdfFile", label: "PDF File", accessor: "" },
    ...(isEmployee
      ? [
          {
            id: "viewEditPdf",
            label: "View Edited Pdf",
            accessor: "viewEditPdf",
          },
        ]
      : []),
    { id: "dxfFile", label: "DWG File", accessor: "dxfFile" },
    { id: "signedPdfUrl", label: "Digital Sign", accessor: "signedPdfUrl" },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const handlePdfModalClose = () => {
    setPdfModalOpen(false);
    setCurrentPdfUrl("");
    setCurrentDocumentIndex(null);
  };

  const getFileStoreId = (url) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.searchParams.get("fileStoreId");
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  };
  const viewEdittedPdf = (url, index) => {
    window.open(url, "_blank");
  };
  const handleOpenDoc = async (url) => {
    const fileStoreId = getFileStoreId(url);
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const { AuthToken, SrcPdfB64 } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return <Loader />;
  }

  console.log("valueInStep4Comp", formData);
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Drawing")}</h2>
          </div>
        </div>

        <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="drawing details  table">
            <TableHead
              sx={{
                backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
                color: "#fff",
              }}
            >
              <TableRow sx={{ height: "20px" }}>
                {columns.map((column) => (
                  <TableCell key={column.id} sx={{ color: "#fff" }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <FaFilePdf
                    color="#a10505"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      isEmployee ? handleOpenPdf(drawingPdfUrl) : getDocumentByFileStoreId(sanctionMapFileStoreId, setIsPreviewLoading)
                    }
                    // onClick={() => handleOpenPdf(drawingPdfUrl)}
                  />
                </TableCell>
                {isEmployee && (
                  <React.Fragment>
                    {formData?.mapSubDetails?.viewEditPdf ? (
                      <TableCell>
                        <FaFilePdf
                          color="#157CB3"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => getDocumentByFileStoreId(formData?.mapSubDetails?.viewEditPdf, setIsPreviewLoading)}
                        />
                      </TableCell>
                    ) : (
                      <TableCell>No File</TableCell>
                    )}
                  </React.Fragment>
                )}
                {completeDrawingDxfFile ? (
                  <TableCell>
                    <FaFilePdf
                      color="#a10505"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                      }}
                      // onClick={() => handleOpenPdf(dxfFileUrl)}
                      onClick={() => getDocumentByFileStoreId(completeDrawingDxfFile[0]?.fileStoreId, setIsPreviewLoading)}
                    />
                  </TableCell>
                ) : (
                  <TableCell>No File</TableCell>
                )}
                <TableCell>
                  {formData?.IsSignedDrawingPdfURL === true && formData?.signedDrawingPdfURL ? (
                    <FaFilePdf
                      color="#24b155"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => window.open(formData.signedDrawingPdfURL, "_blank")}
                      title="View Signed PDF"
                    />
                  ) : !isEmployee ? (
                    <button
                      style={{
                        backgroundColor: "#157CB3",
                        color: "#fff",
                        padding: "8px 16px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        opacity: 1,
                      }}
                      type="button"
                      onClick={handleSign}
                    >
                      Attach Digital Sign
                    </button>
                  ) : (
                    "N/A"
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* PDF Viewer Modal */}
        <PdfViewerModal
          open={pdfModalOpen}
          onClose={handlePdfModalClose}
          pdfUrl={currentPdfUrl}
          onSave={handlePdfSave}
          documentIndex={currentDocumentIndex}
          fileStoreId={currFileStoreId}
        />
        {/* Modal overlay */}
        <div
          style={{
            display: open ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              background: "#fff",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            }}
          >
            <p style={{ margin: "15px" }}>By clicking on the Submit button, you will be redirected to the Third-Party Page.</p>
            <form
              id="PDFViewerDemo"
              method="POST"
              //target="_blank"
              ref={(el) => (formRef.current = el)}
              onSubmit={handleSubmit(onSubmit)}
              action="https://digital.abmapplication.com/Console/PdfViewerSigning"
            >
              <input type="hidden" id="AuthToken" name="AuthToken" value={signingParams.AuthToken} />
              <input type="hidden" id="SignSettingName" name="SignSettingName" value={signingParams.SignSettingName} />
              <input type="hidden" id="SrcPdfB64" name="SrcPdfB64" value={signingParams.SrcPdfB64} />
              <input type="hidden" id="SrcPdfPath" name="SrcPdfPath" value="" />
              <input type="hidden" id="SignedPdfPath" name="SignedPdfPath" value="" />
              <input type="hidden" id="UserDataJson" name="UserDataJson" value={signingParams.UserDataJson} />
              <input
                type="hidden"
                id="ReturnUrl"
                name="ReturnUrl"
                value={signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"}
              />

              <div class="button-inline">
                <div style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    onClick={handleClose}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Cancel
                  </button>
                  <button
                    value="Submit"
                    type="submit"
                    onClick={OpenPDFFromB64InPdfViewer}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {!isEmployee && !isNocModule && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                // onClick={() => handleTabChange(4)}
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default Step4Comp;
